import axios from 'axios'
import decode from 'jwt-decode'

const API_URLS = {
  dev: process.env.DEV_API_URL,
  live: process.env.LIVE_API_URL,
  beta: process.env.BETA_API_URL
}

export const CDN_URL = process.env.CDN_URL

const TOKEN_HEADER_KEY = 'x-authorization'

let api = axios.create()

function setup (jwt) {
  try {
    const { sys, api: version } = decode(jwt)
    api.defaults.baseURL = API_URLS[sys]
    api.defaults.headers['Accept'] = `${api.defaults.headers.common['Accept']}, application/vnd.motocompano.api+json;version=${version || 7}`
    api.defaults.headers[TOKEN_HEADER_KEY] = jwt
    return true
  } catch (e) {
    return false
  }
}

const getInfo = (id) => api.get(`/info?id=${id}&type=videotrack`)
const getUser = (id) => api.get(`/users/index?user=${id}`)
const getGraph = (url) => axios.get(url)

export default {
  setup,
  getInfo,
  getUser,
  getGraph
}



// WEBPACK FOOTER //
// ./src/api.js